import React from 'react'

const BAR_COUNT = 12
// One height per bar (px), shaped like a typical mood distribution so the
// placeholder does not read as a repeating pattern. Max stays under the
// 130px track so no bar overflows it.
const BAR_HEIGHTS = [82, 104, 118, 124, 72, 46, 38, 66, 94, 110, 42, 88]

const BarChartClassroomSkeleton = () => {
    return (
        <div style={{ width: '100%', paddingTop: 30, position: 'relative' }}>
            <div
                className="w-full h-full flex flex-col items-center justify-center"
                style={{
                    height: 130,
                    position: 'relative',
                    background: '#f8f8fb',
                }}
            >
                {/* Vertical bars */}
                <div
                    className="classroom-barchart-grid"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 3,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'flex-end',
                    }}
                >
                    {Array.from({ length: BAR_COUNT }).map((_, idx) => (
                        <div
                            key={idx}
                            style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                padding: '0 4px',
                            }}
                        >
                            <div
                                className="animate-pulse"
                                style={{
                                    width: '85%',
                                    height: BAR_HEIGHTS[idx % BAR_HEIGHTS.length],
                                    borderRadius: 6,
                                    background: '#ecebf8',
                                    marginBottom: 8,
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
            {/* Labels */}
            <div
                className="classroom-barchart-grid"
                style={{
                    marginTop: 9,
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                }}
            >
                {Array.from({ length: BAR_COUNT }).map((_, idx) => (
                    <div
                        key={idx}
                        style={{
                            flex: 1,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <div
                            className="animate-pulse"
                            style={{
                                width: 24,
                                height: 24,
                                borderRadius: 16,
                                background: '#ecebf8',
                                marginBottom: 6,
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BarChartClassroomSkeleton
